<script lang="ts">
  import {createEventDispatcher} from 'svelte';
  import {selected} from "../domain/store";

  export let toggleImageMessage: string;

  const dispatch = createEventDispatcher();

  const emitDownvote = () => dispatch("downvote", $selected.workflowExecution.id);
  const emitUpvote = () => dispatch("upvote", $selected.workflowExecution.id);
  const emitToggleShowInput = () => dispatch("toggleShowInput");

</script>

<footer>
  <div class="button-row">
    <button disabled="{$selected.resultImageState.loading}" on:click={emitDownvote}>Downvote</button>
    <button disabled="{$selected.resultImageState.loading}" on:click={emitToggleShowInput}>{toggleImageMessage}</button>
    <button disabled="{$selected.resultImageState.loading}" on:click={emitUpvote}>Upvote</button>
  </div>
</footer>

<style>
    footer {
        flex: 0 0 50px;
        width: 100%;
        background: #FFF8F0;
    }

    .button-row {
        flex: 1 1 auto;
        overflow: hidden;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 10px 10px 0;
    }

    .button-row button:not(:last-child) {
        margin-right: 10px;
    }
</style>
